import { FeatureFlag } from '@/common';
import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import NotFoundPage from '../routes/NotFoundPage';
import { Loader } from './ui/loader';

interface FeatureFlagProtectedRouteProps {
  children: React.ReactNode;
  flag: FeatureFlag;
}

export function FeatureFlagProtectedRoute({ children, flag }: FeatureFlagProtectedRouteProps) {
  const { enabled: isFeatureFlagEnabled, isLoading } = useIsFeatureFlagEnabled(flag);

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center" data-testid="loader">
        <Loader />
      </div>
    );
  }

  if (!isFeatureFlagEnabled) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
}
